import { forwardRef, type HTMLAttributes } from "react"
import { cn } from "@/lib/cn"

export type BadgeVariant = "neutral" | "primary" | "success" | "warning" | "danger"

const VARIANT: Record<BadgeVariant, string> = {
  neutral: "bg-markv-surface-200 text-markv-text-700",
  primary: "bg-markv-primary-soft text-markv-primary-soft-fg",
  success: "bg-markv-success-soft text-markv-success-soft-fg",
  warning: "bg-markv-warning-soft text-markv-warning-soft-fg",
  danger: "bg-markv-danger-soft text-markv-danger-soft-fg",
}

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: BadgeVariant
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { variant = "neutral", className, ...rest },
  ref,
) {
  return (
    <span
      ref={ref}
      data-variant={variant}
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        VARIANT[variant],
        className,
      )}
      {...rest}
    />
  )
})
